module.exports = __webpack_public_path__ + "img/Slide9.1463e37c.png";